import React from 'react';
import { motion } from 'framer-motion';
import { Terminal, Book, Github } from 'lucide-react';
import styles from './DeveloperPlayground.module.css';

const DeveloperPlayground = () => {
  return (
    <section className={`${styles.playground} section`}>
      <div className="container">
        <motion.div
          className={styles.content}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className={styles.title}>Developer Playground</h2>
          <p className={styles.subtitle}>
            Get started in minutes with our comprehensive developer tools
          </p>

          <div className={styles.codeBlocks}>
            <motion.div
              className={styles.terminal}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <div className={styles.terminalHeader}>
                <div className={styles.dots}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span>Terminal</span>
              </div>
              <code>npx create-gamble-app my-solana-game</code>
            </motion.div>

            <motion.div
              className={styles.code}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <div className={styles.codeHeader}>
                <span>Example.js</span>
              </div>
              <pre>
                {`playGame({
  game: 'coinflip',
  token: 'USDC',
  amount: 1,
  direction: 'heads'
});`}
              </pre>
            </motion.div>
          </div>

          <div className={styles.actions}>
            <a href="#docs" className={styles.button}>
              <Book size={20} />
              View Docs
            </a>
            <a href="#github" className={styles.button}>
              <Github size={20} />
              Explore GitHub
            </a>
            <a href="#devnet" className={styles.button}>
              <Terminal size={20} />
              Try on Devnet
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default DeveloperPlayground; 